import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { authCallbackTriggered } from '../../../../auth/state/auth.actions';

@Component({
  selector: 'app-login-callback',
  standalone: true,
  imports: [],
  template: '',
})
export class LoginCallbackComponent implements OnInit {
  private store = inject(Store);

  ngOnInit(): void {
    this.store.dispatch(authCallbackTriggered());
  }
}
